<div class="open-task-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" *ngIf="tasks != null && tasks.length > 0" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.open-task-editor.has-open-task-of-type"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="taskTypeExternalKey" name="taskTypeExternalKey">
                <mat-option *ngFor="let task of tasks" [value]="task.externalKey">
                  <sc-dictionary-label [dictionaryKey]="task.nameDictionaryKey"></sc-dictionary-label>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
